const actions = {
	
	FETCH_RATES_BEGIN: 'FETCH_RATES_BEGIN',
	FETCH_RATES_SUCCESS: 'FETCH_RATES_SUCCESS',
	FETCH_RATES_ERR: 'FETCH_RATES_ERR',
	FETCH_RATES_BEGIN_MULTI_BOX: 'FETCH_RATES_BEGIN_MULTI_BOX',
	FETCH_RATES_SUCCESS_MULTI_BOX: 'FETCH_RATES_SUCCESS_MULTI_BOX',

	fetchRatesBegin: () => {
		return {
			type: actions.FETCH_RATES_BEGIN,
		};
	},
	fetchRatesBeginMultiBox: () => {
		return {
			type: actions.FETCH_RATES_BEGIN_MULTI_BOX,
		};
	},

	fetchRatesSuccess: (data) => {
		return {
			type: actions.FETCH_RATES_SUCCESS,
			data,
		};
	},
	
	fetchRatesSuccessMultiBox: (data) => {
		console.log('data',data);
		return {
			type: actions.FETCH_RATES_SUCCESS_MULTI_BOX,
			data,
		};
	},

	fetchRatesErr: (err) => {
		return {
			type: actions.FETCH_RATES_ERR,
			err,
		};
	},

};

export default actions;
